<script>

    let { children } = $props();

</script>

<nav>
    {@render children?.()}
</nav>

<style>

    nav {
        display: flex;
        justify-content: flex-end;
        margin-top: 2em;
        margin-bottom: 2em;
        gap: 1em;

        flex-wrap: wrap;
    }

    nav:last-child {
        margin-bottom: 0;
    }

</style>